module.exports = __webpack_public_path__ + "img/apilo.8c88f7b8.png";